import axios from "axios";

export class AddressAPI {
  constructor(baseURL = process.env.VUE_APP_AWESOME_API_URL) {
    this.instance = axios.create({
      baseURL,
    });
  }
  async getAddresByZipCode(zipCode) {
    return await new Promise((resolve, reject) => {
      this.instance
        .request({
          url: zipCode,
          method: "GET",
        })
        .then((result) => {
          return resolve(result);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }
}

const api = new AddressAPI();

export default api;
